export default {
  w4d: "4D",
  coming_soon: "မကြာမီ...",
  virtual_games: "Virtual",
  support: "ဆက်သွယ်ရန်",
  bet_limit: "သတ်မှတ်လောင်းကြေး",
  favorites: "နှစ်သက်ရာ",
  note: "သတိ",
  my_bets: "My Bets",
  my_account: "အကောင့်",
  contact_us: "ဆက်သွယ်ရန်",
  report: "တင်ပြသည်",
  help_support: "အကူအညီနှင့်ထောက်ပံ့မှု",
  currency: "ငွေကြေးပုံစံ",
  others: "အခြား",
  welcome: "ကြိုဆိုပါသည်",
  account_id: "အကောင့်အိုင်ဒီ",
  password: "စကားဝှက်",
  account: "အကောင့်",
  all_sports: "အားကစား အားလုံး",
  my_sports: "အားကစားပွဲများ",
  action: "ပြုလုပ်သည်",
  accept_better_odds: "အလိုအလျောက် ပိုကောင်းသည့်ပေါက်ကြေးလက်ခံခြင်း",
  accept_any_odds: "အလိုအလျောက် ပေါက်ကြေးလက်ခံခြင်း",
  auto_refresh_odds: "ပေါက်ကြေးအလိုအလျောက် ပြောင်းလဲခြင်း",
  auto_refresh: "အလိုအလျောက်ပြောင်းလဲခြင်း",
  auto_refreshing: "အလိုအလျောက်ပြောင်းလဲနေသည်...",
  all_markets: "ပေါက်ကြေးအားလုံး",

  away: "အ‌ဝေး",

  all: "အားလုံး",
  accepted: "လက်ခံသည်",
  add_to_parlay: "မောင်းထည့်သွင်းသည်",
  add_to_booster: "booster အား လက်ခံသည်",
  amount: "ပမာဏ",
  amount_before_balance: "အလျော်အစားမလုပ်ခင် ပမာဏ",
  amount_after_balance: "အလျော်အစားလုပ်ပြီး ပမာဏ",

  bet_slip: "လောင်းကြေးစလစ်",
  bet_credit: "လောင်းကြေး",
  bet_list: "‌လောင်းထားသည့် ဇယား",
  betting: "လောင်းနေသည်",
  balance: "လက်ကျန်",

  betting_statement: "လောင်းကြေးစာရင်း",
  bet_types: "လောင်းကြေးပုံစံ",
  bet_type: "လောင်းကြေးပုံစံ",
  bs: "အကြီး / အသေး",
  bet_summary: "လောင်းကြေးအနှစ်ချုပ်",
  bet_reject: "လောင်းကြေးအား ဖျက်သိမ်းသည်",
  bets: "လောင်းကြေးများ",
  bet: "လောင်းသည်",
  booster: "booster",

  casino: "ကာစီနို",
  mini_casino: "Mini Casino",
  cash_balance: "လက်ငင်းငွေလက်ကျန်",
  change_account_password: "အကောင့်စကားဝှက်အား ပြောင်းသည်",
  current_password: "လက်ရှိစကားဝှက်",
  confirm_new_password: "စကားဝှက်အသစ်အား အတည်ပြုသည်",
  customize_sports_order: "အားကစားပွဲအစဥ်လိုက်များအား ကိုယ်ပိုင်ဖန်တီးမှု",
  choice: "ရွေးချယ်သည်",
  credit: "အကြွေး",
  commission: "ကော်မရှင်",
  customize: "ကိုယ်ပိုင်ဖန်တီးမှု",
  cancel: "ပယ်ဖျက်သည်",
  confirmation: "အတည်ပြုသည်",
  closing_balance: "အပိတ်စာရင်းချုပ်",
  clear_filter: "ရွေးချယ်မှုများအား ဖယ်ရှားသည်",

  debit: "ဝင်ငွေ",
  display_language: "ဘာသာစကားဖော်ပြခြင်း",
  default_event_sorting: "ပုံမှန်ထည့်သွင်းထားသော ပွဲစဥ်များ",
  default_stake: "ပုံမှန်ထည့်သွင်းထားသော လောင်းကြေး",
  date: "ရက်စွဲ",
  draw: "သရေ",
  draw_cancel: "သရေ",
  dec: "ဥရောပပေါက်ကြေး",
  double_line: "ပေါက်ကြေး ၂ မျိုး",
  disable: "မပြုလုပ်နိုင်",
  dec_odds: "ဥရောပပေါက်ကြေး",
  id_odds: "အင်ဒိုပေါက်ကြေး",
  double_chance: "နှစ်ထပ်အခွင့်အရေး",

  enable: "အသုံးပြုသည်",
  event_sorting: "event_sorting",
  edit: "ပြုပြင်",
  early: "အစောပွဲများ",
  event: "ပွဲစဥ်",
  even: "စုံ",

  first_goal: "ပထမဂိုး",
  first_half: "ပထမပိုင်း ရလဒ်",
  final: "နောက်ဆုံး ရလဒ်",
  full_time: "ပွဲချိန်ပြည့်",
  first_5_inn: "First 5 Innings",

  games: "ကစားပွဲများ",
  given_credit: "ပေးထားသော အကြွေး",
  group: "အုပ်စု",
  goal: "ဂိုး",

  half_time: "ပထမပိုင်း",
  hide_header: "ခေါင်းစဥ်များအား ဖျောက်ထားသည်",
  hk: "ဟောင်ကောင်",
  hk_odds: "ဟောင်ကောင် ပေါက်ကြေး",
  home: "အိမ်ကွင်း",

  id: "အင်ဒို",
  inactive: "Inactive",
  inplay: "In-Play",

  keno: "Keno",
  kickoff: "ပွဲစသည်",

  lottery: "Lottery",
  login: "ဝင်ရောက်သည်",
  logout: "ထွက်သည်",
  last_login: "နောက်ဆုံး ဝင်ရောက်ခြင်း",
  last_transaction: "နောက်ဆုံး စာရင်း",
  live_streaming: "တိုက်ရိုက် ထုတ်လွှင့်မှု",
  live_tv: "တိုက်ရိုက် TV",
  live_match: "တိုက်ရိုက် ကစားပွဲ",
  live: "တိုက်ရိုက်",
  live_center: "တိုက်ရိုက် အစီအစဥ်",
  livecasino: "တိုက်ရိုက် ကာစီနို",
  loss: "အရှုံး",
  lost: "ရှုံးသည်",
  lose: "ရှုံးသည်",
  lose_half: "တဝက်ရှုံး",
  last_bet: "နောက်ဆုံး လောင်းကြေး",
  last_goal: "နောက်ဆုံးဂိုး",

  mobile: "ဖုန်း",
  message: "အ‌ကြောင်းကြားစာ",
  my_bet: "မိမိကစားထားသော ပွဲများ",
  my_favorites: "မိမိ အနှစ်သက်ဆုံး",
  market_type: "ပေါက်ကြေးအမျိုးအစား",
  match: "ပွဲစဥ်",
  message_history: "အကြောင်းကြားစာ",
  my: "ကျွန်ုပ်",
  market: "ပေါက်ကြေး",
  main_markets: "အဓိကပေါက်ကြေး",
  my_odds: "မလေး ပေါက်ကြေး",
  min: "အနည်းဆုံး",
  max: "အများဆုံး",
  max_payout: "အများဆုံး လျော်ကြေး",
  main: "အဓိက",
  corners: "‌ဒေါင့်ကန်ဘော",
  specials: "အထူး",
  mix_parlay: "မောင်း",
  moneyline: "အနိင်",

  no_goal: "ဂိုးမရှိပါ",
  normal_announcements: "ပုံမှန် သတိ‌ပေးစာ",
  nickname: "Nickname",
  new_password: "စကားဝှက်အသစ်",
  new: "အသစ်",
  "no/": "No.",
  normal_sorting: "မူရင်းအစဥ်အလိုက်",

  other_markets: "အခြားပေါက်ကြေး",
  outstanding: "ပွဲမပြီးသေးသော လောင်းကြေးများ",
  odds_type: "ပေါက်ကြေးအမျိုးအစား",
  odds: "ပေါက်ကြေး",
  opening_balance: "မူလငွေပမာဏ",
  outright: " ဖလားခန့်မှန်း",
  on: "ON",
  off: "OFF",
  outstanding_bet: "ပွဲမပြီးသေးသော လောင်းကြေးများ",
  over: "အပေါ်",
  odd: "မ",
  hdp: "ပေါက်ကြေး",
  ou: "ဂိုးပေါ်/ ဂိုးအောက်",
  oe: "မ/စုံ",
  oxt: "1X2",
  ml: "အနိုင်",

  password_expiry: "စကားဝှက်သက်တမ်းကုန်ဆုံးသည်",
  parlay: "မောင်း",
  page_display: "စာမျက်နှာ ပုံစံ",
  page_type: "စာမျက်နှာ အမျိုးအစား",
  page_size: "စာမျက်နှာ အရွယ်အစား",
  personal_message: "ကိုယ်ရေးအကြောင်းအရာ",
  process_bet: "လောင်းငွေပမာဏ",
  payout: "လျော်ငွေ ပမာဏ",
  pending: "စောင့်ဆိုင်းနေသည်",

  quick_bet: "အမြန်လောင်းသည်",
  quick_bet_stake: "အမြန်လောင်းသည့် ငွေကြေးပမာဏ",

  result: "ရလဒ်",
  restore: "မူလအခြေအနေသို့",
  remark: "မှတ်သားသည်",
  ref_no: "Ref No.",
  remove_from_parlay: "မောင်းကစားခြင်းမှ ဖယ်ရှားသည်",
  remove_from_booster: "booster အား ဖယ်ရှားသည်",
  running: "လုပ်ဆောင်နေသည်",
  rules: "စည်းမျဥ်းစည်းကမ်း",
  rules_regulations: "စည်းမျဥ်းစည်းကမ်း",

  sports: "အားကစားများ",
  show_balance: "လက်ကျန်ငွေ ပြသရန်",
  statement: "စာရင်း",
  settings: "ပြင်ဆင်ရန်",
  search_team: "အသင်းရှာသည်",
  show_header: "ခေါင်းစဥ်ပြသရန်",
  submit: "အတည်ပြုသည်",
  set_nickname: "Nickname ပြုလုပ်သည်",
  single: "တစ်မျိုးတည်း",
  save: "သိမ်းဆည်းသည်",
  show_score_map: "ပွဲစဥ်ခန့်မှန်းဇယားပုံ ပြသရန်",
  stake: "လောင်းကြေးပမာဏ",
  status: "အချက်အလက်",
  sort: "အပိုင်းအခြား",
  sportsbook: "အားကစား စုစည်းမှုများ",
  sum: "ပေါင်းခြင်း",
  special_announcements: "အထူးသတိပေးချက်များ",
  subtotal: "အသေးစားစာရင်းချုပ်",
  single_line: "တစ်ကြောင်းတည်း",
  sort_by_time: "အချိန်နှင့်ပိုင်းခြားထားသည်",
  slots: "Slots",
  mini_slots: "Mini Slots",
  select_leagues: "လိဒ်များရွေးချယ်သည်",
  settled_amount: "ငွေရှင်းပြီး",

  turnover: "အတည်ပြုသည့်ငွေပမာဏ",
  today: "ယနေ့ပွဲစဥ်",
  time: "အချိန်",
  team: "အသင်း",
  to: "သို့",
  trans_time: "အတည်ပြုချိန်",
  total: "စုစုပေါင်း",
  total_goal: "ဂိုးအရေအတွက်",
  treble: "Treble",
  transaction_date: "အတည်ပြုရက်",
  transfer_method: "ငွေလွှဲအမျိုးအစား",
  transfer: "ငွေလွှဲ",

  under: "အောက်",
  void: "ဖျက်သိမ်းသည်",
  reject: "ပယ်ဖျက်သည်",
  rejected: "ပယ်ဖျက်သည်",
  valid_turnover: "အနိုင်အရှုံးငွေပမာဏ",

  win: "နိုင်သည်",
  won: "နိုင်သည်",
  won_half: "တဝက်နိုင်သည်",
  waiting: "စောင့်ဆိုင်းနေသည်",

  yes: "Yes",
  no: "No",

  yesterday: "မနေ့က",
  monday: "တနင်္လာ",
  tuesday: "အင်္ဂါ",
  wednesday: "ဗုဒ္ဓဟူး",
  thursday: "ကြာသပတေး",
  friday: "သောကြာ",
  saturday: "စနေ",
  sunday: "တနင်္ဂနွေ",

  all_league: "လိဒ်အားလုံး",
  match_completed: "ပွဲချိန်ပြီးဆုံး",
  match_pending: "ရလဒ်စောင့်ဆိုင်း",
  match_cancelled: "ပွဲပျက်",
  match_cancelled_1h: "ပထမပိုင်း ပွဲပျက်",
  match_cancelled_2h: "ဒုတိယပိုင်း ပွဲပျက်",
  match_suspended: "ပွဲပျက်",
  match_suspended_1h: "ပထမပိုင်း ပွဲပျက်",
  match_suspended_2h: "ဒုတိယပိုင်း ပွဲပျက်",

  check_all: "အားလုံးမှတ်ယူသည်",
  selected_only: "မှတ်သားထားသည့် အရာများသာ",
  filtered: "စီစစ်ထားသည်",
  turn_on: "ON",
  turn_off: "OFF",

  preference: "မိမိအကြိုက်များ",

  market_1: "အစောပိုင်းပေါက်ကြေး",
  market_2: "ယနေ့ပွဲစဥ် ",
  market_3: "ပွဲချိန်တွင်း ပေါက်ကြေး",

  // RULES & REGULATION

  // asian_handicap: "အာရှ ပေါက်ကြေး",
  // acceptance_countdown: "အချိန်ရေတွက်ခြင်းအား လက်ခံသည်",
  // acceptance_rules: "ကစားသည့် စည်းမျဥ်းစည်းကမ်းများအား လက်ခံသည်",
  // application_betting_rule: "အထွေထွေစည်းမျဥ်းစည်းကမ်းများ",
  // bettype_settlement_rule: "ကစားနည်းအမျိုးအစားနှင့် စာရင်းဇယားစည်းမျဥ်းများ",
  // change_schedule: "အချိန်ဇယားပြောင်းလဲခြင်း",
  // change_venue: "ကစားသည့်တည်နေရာပြောင်းလဲခြင်း",
  // cons_interpret: "ဘာသာပြန်ခြင်း",
  // definition_of_term: "အခေါ်အဝေါ်သတ်မှတ်ခြင်း",
  // general_betting_rule: "အထွေထွေ ကစားနည်းစည်းမျဥ်း",
  // general_terms: "အထွေထွေ စည်းမျဥ်းစည်းကမ်း",
  // general_provision: "အထွေထွေ စည်းမျဥ်း",
  // general_rules_bt: "အထွေထွေ စည်းမျဥ်း ပေါက်ကြေး (ကစားနည်း)",
  // handicaps: "ပေါက်ကြေး (HDP) ၊ ပထမပိုင်း ပေါက်ကြေး (1H HDP) ၊ ''ဒုတိယပိုင်း ပေါက်ကြေး(2H HDP)",
  // running_bet_service: 'ပွဲချိန်တွင်း ကစားခြင်း',
  // limitation_provision: "တာဝန်ယူခြင်းနှင့်အလျော်အစားစည်းမျဥ်းစည်းကမ်း",
  // match_duration: "ပွဲချိန်",
  // member_account: "ကစားသူအကောင့်",
  // mixparlays: "မောင်း",
  // mixparlay_payout: "မောင်းကစားခြင်း၏ အများဆုံးလျော်ကြေး",
  // over_unders: "ဂိုးပေါ် / ဂိုးအောက် (OU) ၊ ပထမပိုင်း ဂိုးပေါ် / ဂိုးအောက် 1H (OU) ၊ ဒုတိယပိုင်း ဂိုးပေါ် / ဂိုးအောက် 2H (OU)",
  // odd_evens: "မ/စုံ (OE) ၊ ပထမပိုင်း မ/စုံ 1H (OE) ၊ ဒုတိယပိုင်း မ/စုံ 2H (OE)",
  // rules_governing: "အထွေအထွေစည်းမျဥ်းစည်းကမ်းနှင့် ထူးခြားဖြစ်စဥ်",
  // results: "ရလဒ်",
  // software_game: "ဆော့ဝဲနှင့် ကစားပွဲ",
  // single_team_oe: "တစ်သင်းတည်း မ/စုံ",
  // sport_betting_rule: "အားကစားပွဲများ၏လောင်းကြေးစည်းမျဥ်းစည်းကမ်း",
  // terms_of_transact: "လောင်းကြေးကစားသည့် စည်းမျဥ်းစည်းကမ်း",
  // warranties: "ကစားသူ၏ အာမခံခြင်းနှင့် ပါဝင်ခြင်း",

  american_football: "အမေရိကန်ဘောလုံး",
  soccer: "ဘောလုံး",
  basketball: "ဘတ်စကက်ဘော",
  baseball: "ဘေ့စ်ဘော",
  esports: "E-Sports",
  tennis: "Tennis",

  events: "အထူးပွဲစဥ်",
  brackets: "Brackets",
  standing: "Standing",

  euro2020: "Euro 2020 Table",

  play_now: "Play Now",

  processing: "လုပ်ဆောင်နေသည်...",

  big_small: "အကြီး/အသေး",
  odd_even: "မ/စုံ",

  first_digit: "ပထမဂဏာန်း",
  second_digit: "ဒုတိယဂဏာန်း",
  third_digit: "တတိယဂဏာန်း",
  forth_digit: "ဂဏာန်း ၄ လုံး",
  total_4d: "Total 4D",
  total_3d: "Total Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",

  official_link: "တရားဝင်းချိတ်ဆက်မှု",

  virtual_sports: "Virtual Sports",
  virtual_soccer: "Virtual Soccer",
  virtual_horse_racing: "Virtual Horse Racing",
  virtual_dog_racing: "Virtual Dog Racing",
  virtual_motorsport: "Virtual Motorsport",

  prize1: "ပထမဆု",
  prize2: "ဒုတိယဆု",
  prize3: "တတိယဆု",

  round1: "ပထမအချီ",
  round2: "ဒုတိယအချီ",
  round3: "တတိယအချီ",
  round4: "စတုထ္ထအချီ",
  round5: "ပဥ္စမအချီ",

  map1: "မြေပုံ 1,",
  map2: "မြေပုံ 2",
  map3: "မြေပုံ 3",
  map4: "မြေပုံ 4",
  map5: "မြေပုံ 5",
  map6: "မြေပုံ 6",
  map7: "မြေပုံ 7",
  map8: "မြေပုံ 8",
  map9: "မြေပုံ 9",
  map10: "မြေပုံ 10",

  ftmode0: "အားလုံး",
  ftmode9: "နောက် ၂ နာရီ",
  ftmode1: "နောက် ၄ နာရီ",
  ftmode2: "နောက် ၈ နာရီ",
  ftmode3: "ယခု - 00:00",
  ftmode4: "00:00 ~ 04:00",
  ftmode5: "04:00 ~ 12:00",

  continue: "ဆက်လက်ရန်",

  highlight: "Highlights",
  show_all_time: "ယနေ့ပွဲစဥ်အားလုံး ပြသရန်",
  back: "နောက်သို့",
  fishing: "ငါးဖမ်းသည်",

  upnext: "ဆက်လက်၍ ပြသ",
  no_video: "ဗီဒီယိုမရှိပါ",

  mm_odds: "မြန်မာပေါက်ကြေး",
  mmo_parlay: "မြန်မာမောင်း",
  myanmar: "မြန်မာ",

  mini_games: "ဂိမ်းအသေးများ",

  abets: "ကစားနည်း",
  afold: "ခေါက်",
  fold: "ခေါက်",

  combo: "ပေါင်းစပ်",
  total_bet: "အလောင်းအစားအားလုံး",
  total_stake: "လောင်းကြေးပမာဏ",
  total_match: "ဂိမ်းအရေအတွက်",
  combination: "ပေါင်းစပ်",
  stakeperbet: "လောင်းကစားတစ်ခု",
  total_payout: "အများဆုံးပေးချေမှု",
  total_accept: "ငွေပမာဏကိုလက်ခံပါ",
  total_reject: "အများဆုံးငြင်းပယ်ခံရ",
  sum_wl: "စုစုပေါင်းအနိုင်ပေးနှင့်ဆုံးရှုံးမှု",
  sum_bet: "အလောင်းအစားအားလုံး",
  score: "နိုင်ပြီ",
  winner: "အောင်နိုင်သူ",

  upcoming: "လာတော့မည်",

  adjustment: "ညှိနှိုင်းမှု",
  poker: "ဖဲချပ်",
  slots: "အထိုင်များ"
};
